/** InsCoder 2026-09-17 B + HP 26 product card row: single swiper + buy button loading **/
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-hp26-pcr]';
  var SLIDER_SELECTOR = '[data-hp26-swiper]';
  var MOBILE_SPACE = 12;
  var DESKTOP_SPACE = 16;
  var MAX_SLIDES = 4;

  function initSection(root) {
    if (!root || root.dataset.hp26PcrReady === 'true') return;

    var sliderEl = root.querySelector(SLIDER_SELECTOR);
    if (!sliderEl) return;
    root.dataset.hp26PcrReady = 'true';

    /** InsCoder 2026-09-17 B + Desktop tracks from Liquid: 2 cards -> 2 (50%), 3 cards -> 3, 4 cards -> 4; 1 card keeps 1/4 **/
    if (window.Swiper && sliderEl.querySelector('.swiper-slide')) {
      var slidesPerView = Number(sliderEl.dataset.hp26Slides) || 1;
      if (slidesPerView > MAX_SLIDES) slidesPerView = MAX_SLIDES;

      new window.Swiper(sliderEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        watchOverflow: true,
        breakpoints: {
          /** InsCoder WANG.J 2026-09-22 B + Mobile: 1.2 cards per view, so Swiper derives the card width from the viewport (the slide no longer has a fixed CSS width) **/
          0: { slidesPerView: 1.2, spaceBetween: MOBILE_SPACE },
          /** InsCoder WANG.J 2026-09-22 E + Mobile: 1.2 cards per view, so Swiper derives the card width from the viewport (the slide no longer has a fixed CSS width) **/
          990: { slidesPerView: slidesPerView, spaceBetween: DESKTOP_SPACE }
        }
      });
    }
    /** InsCoder 2026-09-17 E + Desktop tracks from Liquid: 2 cards -> 2 (50%), 3 cards -> 3, 4 cards -> 4; 1 card keeps 1/4 **/

    /** InsCoder 2026-09-17 B + Buy button loading state only (add to cart / checkout is handled by the global .checkoutButton flow in theme.js) **/
    function setLoading(button) {
      if (button.classList.contains('is-loading')) return;
      if (button.getAttribute('aria-disabled') === 'true') return;
      button.classList.add('is-loading');
    }

    function clearLoading() {
      root.querySelectorAll('[data-hp26-atc].is-loading').forEach(function (button) {
        button.classList.remove('is-loading');
      });
    }

    root.querySelectorAll('[data-hp26-atc]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        setLoading(button);
      });
    });

    // Clear the stuck loading state when the page is restored from bfcache (browser back)
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) clearLoading();
    });
    /** InsCoder 2026-09-17 E + Buy button loading state only (add to cart / checkout is handled by the global .checkoutButton flow in theme.js) **/
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target || !target.querySelector) return;

    var root = target.matches && target.matches(ROOT_SELECTOR)
      ? target
      : target.querySelector(ROOT_SELECTOR);

    if (root) initSection(root);
    else initAll();
  });
})();
/** InsCoder 2026-09-17 E + HP 26 product card row: single swiper + buy button loading **/
